function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("title", null, "check-filled-alt");

var _ref3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
  d: "M16,0 C18.912,0 21.568,0.736 24.032,2.144 C26.496,3.552 28.448,5.504 29.856,7.968 C31.296,10.432 32,13.088 32,16 C32,18.88 31.264,21.568 29.856,24.032 C28.448,26.496 26.496,28.448 24.032,29.856 C21.568,31.296 18.88,32 16,32 C13.12,32 10.432,31.296 7.968,29.856 C5.504,28.448 3.584,26.496 2.144,24.032 C0.704,21.568 0,18.88 0,16 C0,13.088 0.704,10.432 2.144,7.968 C3.584,5.504 5.504,3.584 7.968,2.144 C10.432,0.704 13.088,0 16,0 Z M23.104,8.856 L22.9092804,8.8644556 C22.4629981,8.90385039 22.0722199,9.08044803 21.7172086,9.3847434 L12.99,18.167 L9.50710678,14.6848932 C9.10046578,14.2782522 8.62449913,14.072 8.064,14.072 L7.87941907,14.0804572 C7.45201805,14.1198672 7.05036866,14.296614 6.73194678,14.6023205 L6.697,14.638 L6.6624421,14.6653302 C6.58919525,14.7294762 6.52564319,14.8012345 6.47026653,14.8787618 L6.42089777,14.9519526 L6.393,14.999 L6.35921929,15.0447405 C6.31603026,15.1104489 6.28286776,15.1769963 6.25370449,15.2496214 L6.219,15.345 L6.20634002,15.3725132 C6.18554047,15.4210916 6.1696656,15.4666936 6.15599589,15.514332 L6.12068976,15.6595824 L6.072,15.8057223 L6.072,16.3222777 L6.12369886,16.4826313 L6.16028443,16.6279271 C6.17611121,16.7016766 6.19930712,16.7699074 6.22878364,16.8387425 L6.33757281,17.0552136 C6.38754236,17.1551527 6.44567043,17.2440545 6.51577872,17.3281844 L6.58123049,17.4020548 L11.6128932,22.4351068 C11.9953445,22.8175581 12.4749125,23.016 13.024,23.016 C13.5730875,23.016 14.0526555,22.8175581 14.4351068,22.4351068 L24.5184927,12.2557046 C24.8925005,11.8817131 25.096,11.3729642 25.096,10.848 C25.096,10.3230358 24.8925005,9.8142869 24.5151068,9.43689322 C24.1326555,9.05444193 23.6530875,8.856 23.104,8.856 Z",
  id: "path-1"
}));

var _ref4 = /*#__PURE__*/React.createElement("g", {
  id: "Publish",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "Wizard--14",
  transform: "translate(-161.000000, -1051.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Content",
  transform: "translate(40.000000, 200.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group-5-Copy",
  transform: "translate(121.000000, 814.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "check-filled-alt",
  transform: "translate(0.000000, 37.000000)"
}, /*#__PURE__*/React.createElement("mask", {
  id: "mask-2",
  fill: "white"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#path-1"
})), /*#__PURE__*/React.createElement("use", {
  id: "Mask",
  fill: "#000000",
  fillRule: "nonzero",
  xlinkHref: "#path-1"
}), /*#__PURE__*/React.createElement("g", {
  id: "color/Positive-(Jade)",
  mask: "url(#mask-2)",
  fill: "#7EA299",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("rect", {
  id: "color",
  x: 0,
  y: 0,
  width: 32,
  height: 32
})))))));

var SvgCheckFilled = function SvgCheckFilled(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "32px",
    height: "32px",
    viewBox: "0 0 32 32",
    ref: svgRef
  }, props), _ref2, _ref3, _ref4);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgCheckFilled, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/check-filled.4e9a55e8.svg";
export { ForwardRef as ReactComponent };